// import {
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableRow,
//   Typography,
//   Table,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
// } from "@mui/material";
// import { Form, Formik } from "formik";
// import moment from "moment";
// import React, { Component } from "react";
// import Credentials, { currentTenant, userid } from "../Common/Credentials";
// import { spin } from "../Common/NewLoader";
// import Footer from "../Component/Footer";
// import Header from "../Component/Header";
// import Menu from "../Component/Menu";
// import withRouter from "../withRouter";
// import NotificationServices from "./NotificationServices";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import Tab from "@mui/material/Tab";
// import {TabContext, TabPanel} from "@mui/lab";
// import TabList from "@mui/lab/TabList";

// class Notifications extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       data: [],
//       unread: "",
//       notificationtype: "Product Based",
//     };
//   }

//   Markallasread() {
//     NotificationServices.MarkAllasRead(currentTenant,userid)
//       .then(
//         (res) => this.refresh()
//         //   this.state.data.map(e=>
//         //  this.state.data.find(i=>i.id===e.id).status=1
//         // )
//       )
//       .catch((e) => {
//         if (e.response.data.error === "Unauthorized") {
//           alert("Your Session is Lost: Please login Back to resume");
//           this.props.navigate(`/`);
//         }
//       });
//   }

//   handleRead(value) {
//     NotificationServices.NotificationsReadStatus(value)
//       .then((res) =>
//         //  this.state.data.find(e=>e.id===value).status=1
//         this.refresh()
//       )
//       .catch((e) => {
//         if (e.response.data.error === "Unauthorized") {
//           alert("Your Session is Lost: Please login Back to resume");
//           this.props.navigate(`/`);
//         }
//       });
//   }

//   refresh() {
//     NotificationServices.GetAllNotifications(currentTenant,userid)
//       .then((res) =>
//         this.setState({
//           data: res.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)),
//           unread: res.data.filter((a) => a.notificationstatus === 0).length,
//         })
//       )
//       .catch((e) => {
//         if (e.response.data.error === "Unauthorized") {
//           alert("Your Session is Lost: Please login Back to resume");
//           this.props.navigate(`/`);
//         }
//       });
//   }
//   componentDidMount() {
//     if (userid === undefined) {
//       window.confirm("Your Session is Lost: Please login Back to resume");
//       this.props.navigate(`/`);
//     }
//     Credentials.setSelectedMenu("Notifications")
//     this.refresh();
//   }
//   render() {
//     return (
//       <div>
//         <Header />
//         <Menu />
//         <div className="content-wrapper">
//           <div className="card">
//             <div className="card-header">
//               <h3 className="card-title textColour">
//                 <i className="fas fa-bell mr-2"></i>Notifications
//               </h3>
//             </div>
//             <div className="form-row m-0">
//               <div className="card-body">
//                 <div>
//                   {this.state.loading === true ? (
//                     <div className="text-center">{spin}</div>
//                   ) : (
//                     <Formik initialValues={{}} enableReinitialize={true}>
//                       {() => (
//                         <Form autoComplete="off">
//                           {/* <fieldset
//                             className={`form-group col-md-3  shadow-sm text-center btn mr-2 ${
//                               this.state.notificationtype === "Product Based"
//                                 ? ""
//                                 : " hovbuttonColour"
//                             }`}
//                             onClick={() =>
//                               this.setState({
//                                 notificationtype: "Product Based",
//                               })
//                             }
//                           >
//                             Product Based
//                           </fieldset>
//                           <fieldset
//                             className={`form-group col-md-3 shadow-sm btn text-center ${
//                               this.state.notificationtype === "All"
//                                 ? ""
//                                 : " hovbuttonColour"
//                             }`}
//                             onClick={() =>
//                               this.setState({ notificationtype: "All" })
//                             }
//                           >
//                             Show All
//                           </fieldset> */}

//                           <TabContext value={this.state.notificationtype}>
//                           <TabList
//                     sx={{borderBottom: 1, borderColor: '#ffdd15'}}
//                     onChange={(event, newValue) => this.setState({
//                       notificationtype: newValue,
//                     })}
//                 >
//                     <Tab label={"Product Based"} value={"Product Based"} sx={{flex: '1 1 auto'}}/>
//                     <Tab label={"All"} value={"All"} sx={{flex: '1 1 auto'}}/>
//                 </TabList>
//                 <TabPanel value="notification" sx={{p: 0}}>
//                   </TabPanel>
//                   </TabContext>

                        

//                           {this.state.notificationtype === "Product Based" ? (
//                             <>
//                               {/* <Typography className="breadcrumb mb-3">
//                                 <span
//                                   style={{
//                                     marginTop: "auto",
//                                     marginBottom: "auto",
//                                     marginLeft: "12px",
//                                   }}
//                                 >
//                                   {this.state.notificationtype}{" "}
//                                 </span>
//                               </Typography> */}
//                               <Accordion>
//                                 <AccordionSummary
//                                   expandIcon={<ExpandMoreIcon />}
//                                   aria-controls="panel1a-content"
//                                   id="panel1a-header"
//                                 >
//                                   <span className="textColour">
//                                     Masters (
//                                     {this.state.data.filter(
//                                       (e) =>
//                                         e.notificationstatus === 0 &&
//                                         e.product === "Masters"
//                                     ).length > 0 ? (
//                                       <>
//                                         {
//                                           this.state.data.filter(
//                                             (e) =>
//                                               e.notificationstatus === 0 &&
//                                               e.product === "Masters"
//                                           ).length
//                                         }
//                                         /
//                                       </>
//                                     ) : (
//                                       ""
//                                     )}
//                                     {
//                                       this.state.data.filter(
//                                         (e) => e.product === "Masters"
//                                       ).length
//                                     }
//                                     )
//                                   </span>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                   <Table>
//                                     <TableBody>
//                                       {this.state.data.map((data, index) =>
//                                         data.product === "Masters" ? (
//                                           <TableRow key={index}>
//                                             <TableCell
//                                         onClick={() => data.notificationstatus === 0 ?this.handleRead(data.id):''}
//                                         className="cursorPointer"
//                                       >
//                                         {data.notificationstatus === 0 ? (
//                                           <i
//                                             className="fas fa-circle textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         ) : (
//                                           <i
//                                             className="fas fa-check textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         )}
//                                         {data.createdbyname === null ? (
//                                           ""
//                                         ) : (
//                                           <span className="text-bold">
//                                             &nbsp;{data.createdbyname} -
//                                           </span>
//                                         )}
//                                                 &nbsp;
//                                                 {data.subject}
//                                                 <br />
//                                                 <span
//                                                   style={{
//                                                     fontSize: "12px",
//                                                   }}
//                                                 >
//                                                   {data.content}
//                                                 </span>
//                                                 <span
//                                                   style={{
//                                                     fontSize: "12px",
//                                                   }}
//                                                   className="float-right"
//                                                 >
//                                                   {moment(
//                                                     data.createdAt
//                                                   ).format("DD-MM-YYYY HH:mm")}
//                                                 </span>
//                                               </TableCell>
//                                           </TableRow>
//                                         ) : (
//                                           ""
//                                         )
//                                       )}
//                                     </TableBody>
//                                   </Table>
//                                 </AccordionDetails>
//                               </Accordion>
//                               <Accordion>
//                                 <AccordionSummary
//                                   expandIcon={<ExpandMoreIcon />}
//                                   aria-controls="panel1a-content"
//                                   id="panel1a-header"
//                                 >
//                                   <span className="textColour">
//                                     Accounts (
//                                     {this.state.data.filter(
//                                       (e) =>
//                                         e.notificationstatus === 0 &&
//                                         e.product === "Accounts"
//                                     ).length > 0 ? (
//                                       <>
//                                         {
//                                           this.state.data.filter(
//                                             (e) =>
//                                               e.notificationstatus === 0 &&
//                                               e.product === "Accounts"
//                                           ).length
//                                         }
//                                         /
//                                       </>
//                                     ) : (
//                                       ""
//                                     )}
//                                     {
//                                       this.state.data.filter(
//                                         (e) => e.product === "Accounts"
//                                       ).length
//                                     }
//                                     )
//                                   </span>
//                                 </AccordionSummary>
//                                 <AccordionDetails></AccordionDetails>
//                               </Accordion>
//                               <Accordion>
//                                 <AccordionSummary
//                                   expandIcon={<ExpandMoreIcon />}
//                                   aria-controls="panel1a-content"
//                                   id="panel1a-header"
//                                 >
//                                   <span className="textColour">
//                                     Inventory (
//                                     {this.state.data.filter(
//                                       (e) =>
//                                         e.notificationstatus === 0 &&
//                                         e.product === "Inventory"
//                                     ).length > 0 ? (
//                                       <>
//                                         {
//                                           this.state.data.filter(
//                                             (e) =>
//                                               e.notificationstatus === 0 &&
//                                               e.product === "Inventory"
//                                           ).length
//                                         }
//                                         /
//                                       </>
//                                     ) : (
//                                       ""
//                                     )}
//                                     {
//                                       this.state.data.filter(
//                                         (e) => e.product === "Inventory"
//                                       ).length
//                                     }
//                                     )
//                                   </span>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                   <Table>
//                                     <TableBody>
//                                       {this.state.data.map((data, index) =>
//                                         data.product === "Inventory" ? (
//                                           <TableRow key={index}>
//                                             <TableCell
//                                         onClick={() => data.notificationstatus === 0 ?this.handleRead(data.id):''}
//                                         className="cursorPointer"
//                                       >
//                                         {data.notificationstatus === 0 ? (
//                                           <i
//                                             className="fas fa-circle textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         ) : (
//                                           <i
//                                             className="fas fa-check textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         )}
//                                         {data.createdbyname === null ? (
//                                           ""
//                                         ) : (
//                                           <span className="text-bold">
//                                             &nbsp;{data.createdbyname} -
//                                           </span>
//                                         )}
//                                                 &nbsp;
//                                                 {data.subject}
//                                                 <br />
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   {data.content}
//                                                 </span>
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                   className="float-right"
//                                                 >
//                                                   {moment(
//                                                     data.createdAt
//                                                   ).format("DD-MM-YYYY HH:mm")}
//                                                 </span>
//                                               </TableCell>
//                                           </TableRow>
//                                         ) : (
//                                           ""
//                                         )
//                                       )}
//                                     </TableBody>
//                                   </Table>
//                                 </AccordionDetails>
//                               </Accordion>
//                               <Accordion>
//                                 <AccordionSummary
//                                   expandIcon={<ExpandMoreIcon />}
//                                   aria-controls="panel1a-content"
//                                   id="panel1a-header"
//                                 >
//                                   <span className="textColour">
//                                     Sales (
//                                     {this.state.data.filter(
//                                       (e) =>
//                                         e.notificationstatus === 0 &&
//                                         e.product === "Sales"
//                                     ).length > 0 ? (
//                                       <>
//                                         {
//                                           this.state.data.filter(
//                                             (e) =>
//                                               e.notificationstatus === 0 &&
//                                               e.product === "Sales"
//                                           ).length
//                                         }
//                                         /
//                                       </>
//                                     ) : (
//                                       ""
//                                     )}
//                                     {
//                                       this.state.data.filter(
//                                         (e) => e.product === "Sales"
//                                       ).length
//                                     }
//                                     )
//                                   </span>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                   <Table>
//                                     <TableBody>
//                                       {this.state.data.map((data, index) =>
//                                         data.product === "Sales" ? (
//                                           <TableRow key={index}>
//                                             <TableCell
//                                         onClick={() => data.notificationstatus === 0 ?this.handleRead(data.id):''}
//                                         className="cursorPointer"
//                                       >
//                                         {data.notificationstatus === 0 ? (
//                                           <i
//                                             className="fas fa-circle textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         ) : (
//                                           <i
//                                             className="fas fa-check textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         )}
//                                         {data.createdbyname === null ? (
//                                           ""
//                                         ) : (
//                                           <span className="text-bold">
//                                             &nbsp;{data.createdbyname} -
//                                           </span>
//                                         )}
//                                                 &nbsp;
//                                                 {data.subject}
//                                                 <br />
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   {data.content}
//                                                 </span>
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                   className="float-right"
//                                                 >
//                                                   {moment(
//                                                     data.createdAt
//                                                   ).format("DD-MM-YYYY HH:mm")}
//                                                 </span>
//                                               </TableCell>
                                           
//                                           </TableRow>
//                                         ) : (
//                                           ""
//                                         )
//                                       )}
//                                     </TableBody>
//                                   </Table>
//                                 </AccordionDetails>
//                               </Accordion>
//                               <Accordion>
//                                 <AccordionSummary
//                                   expandIcon={<ExpandMoreIcon />}
//                                   aria-controls="panel1a-content"
//                                   id="panel1a-header"
//                                 >
//                                   <span className="textColour">
//                                     Purchase (
//                                     {this.state.data.filter(
//                                       (e) =>
//                                         e.notificationstatus === 0 &&
//                                         e.product === "Purchase"
//                                     ).length > 0 ? (
//                                       <>
//                                         {
//                                           this.state.data.filter(
//                                             (e) =>
//                                               e.notificationstatus === 0 &&
//                                               e.product === "Purchase"
//                                           ).length
//                                         }
//                                         /
//                                       </>
//                                     ) : (
//                                       ""
//                                     )}
//                                     {
//                                       this.state.data.filter(
//                                         (e) => e.product === "Purchase"
//                                       ).length
//                                     }
//                                     )
//                                   </span>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                   <Table>
//                                     <TableBody>
//                                       {this.state.data.map((data, index) =>
//                                         data.product === "Purchase" ? (
//                                           <TableRow key={index}>
//                                             <TableCell
//                                         onClick={() => data.notificationstatus === 0 ?this.handleRead(data.id):''}
//                                         className="cursorPointer"
//                                       >
//                                         {data.notificationstatus === 0 ? (
//                                           <i
//                                             className="fas fa-circle textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         ) : (
//                                           <i
//                                             className="fas fa-check textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         )}
//                                         {data.createdbyname === null ? (
//                                           ""
//                                         ) : (
//                                           <span className="text-bold">
//                                             &nbsp;{data.createdbyname} -
//                                           </span>
//                                         )}
//                                                 &nbsp;
//                                                 {data.subject}
//                                                 <br />
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   {data.content}
//                                                 </span>
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                   className="float-right"
//                                                 >
//                                                   {moment(
//                                                     data.createdAt
//                                                   ).format("DD-MM-YYYY HH:mm")}
//                                                 </span>
//                                               </TableCell>
                                          
//                                           </TableRow>
//                                         ) : (
//                                           ""
//                                         )
//                                       )}
//                                     </TableBody>
//                                   </Table>
//                                 </AccordionDetails>
//                               </Accordion>
//                               <Accordion>
//                                 <AccordionSummary
//                                   expandIcon={<ExpandMoreIcon />}
//                                   aria-controls="panel1a-content"
//                                   id="panel1a-header"
//                                 >
//                                   <span className="textColour">
//                                     Production (
//                                     {this.state.data.filter(
//                                       (e) =>
//                                         e.notificationstatus === 0 &&
//                                         e.product === "Production"
//                                     ).length > 0 ? (
//                                       <>
//                                         {
//                                           this.state.data.filter(
//                                             (e) =>
//                                               e.notificationstatus === 0 &&
//                                               e.product === "Production"
//                                           ).length
//                                         }
//                                         /
//                                       </>
//                                     ) : (
//                                       ""
//                                     )}
//                                     {
//                                       this.state.data.filter(
//                                         (e) => e.product === "Production"
//                                       ).length
//                                     }
//                                     )
//                                   </span>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                   <Table>
//                                     <TableBody>
//                                       {this.state.data.map((data, index) =>
//                                         data.product === "Production" ? (
//                                           <TableRow key={index}>
//                                             <TableCell
//                                         onClick={() => data.notificationstatus === 0 ?this.handleRead(data.id):''}
//                                         className="cursorPointer"
//                                       >
//                                         {data.notificationstatus === 0 ? (
//                                           <i
//                                             className="fas fa-circle textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         ) : (
//                                           <i
//                                             className="fas fa-check textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         )}
//                                         {data.createdbyname === null ? (
//                                           ""
//                                         ) : (
//                                           <span className="text-bold">
//                                             &nbsp;{data.createdbyname} -
//                                           </span>
//                                         )}
//                                                 &nbsp;
//                                                 {data.subject}
//                                                 <br />
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   {data.content}
//                                                 </span>
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                   className="float-right"
//                                                 >
//                                                   {moment(
//                                                     data.createdAt
//                                                   ).format("DD-MM-YYYY HH:mm")}
//                                                 </span>
//                                               </TableCell>
                                           
//                                           </TableRow>
//                                         ) : (
//                                           ""
//                                         )
//                                       )}
//                                     </TableBody>
//                                   </Table>
//                                 </AccordionDetails>
//                               </Accordion>
//                               <Accordion>
//                                 <AccordionSummary
//                                   expandIcon={<ExpandMoreIcon />}
//                                   aria-controls="panel1a-content"
//                                   id="panel1a-header"
//                                 >
//                                   <span className="textColour">
//                                     Assets (
//                                     {this.state.data.filter(
//                                       (e) =>
//                                         e.notificationstatus === 0 &&
//                                         e.product === "Assets"
//                                     ).length > 0 ? (
//                                       <>
//                                         {
//                                           this.state.data.filter(
//                                             (e) =>
//                                               e.notificationstatus === 0 &&
//                                               e.product === "Assets"
//                                           ).length
//                                         }
//                                         /
//                                       </>
//                                     ) : (
//                                       ""
//                                     )}
//                                     {
//                                       this.state.data.filter(
//                                         (e) => e.product === "Assets"
//                                       ).length
//                                     }
//                                     )
//                                   </span>
//                                 </AccordionSummary>
//                                 <AccordionDetails>
//                                   <Table>
//                                     <TableBody>
//                                       {this.state.data.map((data, index) =>
//                                         data.product === "Assets" ? (
//                                           <TableRow key={index}>
//                                            <TableCell
//                                         onClick={() => data.notificationstatus === 0 ?this.handleRead(data.id):''}
//                                         className="cursorPointer"
//                                       >
//                                         {data.notificationstatus === 0 ? (
//                                           <i
//                                             className="fas fa-circle textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         ) : (
//                                           <i
//                                             className="fas fa-check textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         )}
//                                         {data.createdbyname === null ? (
//                                           ""
//                                         ) : (
//                                           <span className="text-bold">
//                                             &nbsp;{data.createdbyname} -
//                                           </span>
//                                         )}
//                                                 &nbsp;
//                                                 {data.subject}
//                                                 <br />
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                 >
//                                                   {data.content}
//                                                 </span>
//                                                 <span
//                                                   style={{ fontSize: "12px" }}
//                                                   className="float-right"
//                                                 >
//                                                   {moment(
//                                                     data.createdAt
//                                                   ).format("DD-MM-YYYY HH:mm")}
//                                                 </span>
//                                               </TableCell>
                                           
//                                           </TableRow>
//                                         ) : (
//                                           ""
//                                         )
//                                       )}
//                                     </TableBody>
//                                   </Table>
//                                 </AccordionDetails>
//                               </Accordion>
//                             </>
//                           ) : (
//                             <TableContainer>
//                               {/* <Typography className="breadcrumb">
//                                 <span
//                                   style={{
//                                     marginTop: "auto",
//                                     marginBottom: "auto",
//                                     marginLeft: "12px",
//                                   }}
//                                 >
//                                   {this.state.notificationtype} (
//                                   {this.state.data.filter(
//                                     (e) => e.notificationstatus === 0
//                                   ).length > 0 ? (
//                                     <>
//                                       {
//                                         this.state.data.filter(
//                                           (e) => e.notificationstatus === 0
//                                         ).length
//                                       }
//                                       /
//                                     </>
//                                   ) : (
//                                     ""
//                                   )}
//                                   {this.state.data.length})
//                                 </span>
//                                 {this.state.unread === 0 ? (
//                                   ""
//                                 ) : (
//                                   <span
//                                     className="btn btn-sm backgroundColour text-white shadow-sm ml-auto"
//                                     onClick={this.Markallasread.bind(this)}
//                                   >
//                                     &nbsp;&nbsp;
//                                     <i className="fas fa-check" />
//                                     &nbsp;Mark all as read
//                                   </span>
//                                 )}
//                               </Typography> */}
//                               <Table>
//                                 <TableBody>
//                                   {this.state.data.map((data, index) => (
//                                     <TableRow key={index}>
//                                       {/* {data.notificationstatus === 0 ? ( */}
//                                       <TableCell
//                                         onClick={() => data.notificationstatus === 0 ?this.handleRead(data.id):''}
//                                         className="cursorPointer"
//                                       >
//                                         {data.notificationstatus === 0 ? (
//                                           <i
//                                             className="fas fa-circle textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         ) : (
//                                           <i
//                                             className="fas fa-check textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                         )}
//                                         {data.createdbyname === null ? (
//                                           ""
//                                         ) : (
//                                           <span className="text-bold">
//                                             &nbsp;{data.createdbyname} -
//                                           </span>
//                                         )}
//                                         &nbsp;{data.subject}
//                                         <br />
//                                         <span style={{ fontSize: "12px" }}>
//                                           {data.content}
//                                         </span>
//                                         <span
//                                           style={{ fontSize: "12px" }}
//                                           className="float-right"
//                                         >
//                                           {moment(data.createdAt).format(
//                                             "DD-MM-YYYY HH:mm"
//                                           )}
//                                         </span>
//                                       </TableCell>
//                                       {/* ) : (
//                                         <TableCell>
//                                           <i
//                                             className="fas fa-check textColour"
//                                             style={{ fontSize: "10px" }}
//                                           />
//                                           {data.createdbyname === null?"":<>&nbsp;{data.createdbyname}</>}
//                                           &nbsp;{data.subject}
//                                           <br />
//                                           <span style={{ fontSize: "12px" }}>
//                                             {data.content}
//                                           </span>
//                                           <span
//                                             style={{ fontSize: "12px" }}
//                                             className="float-right"
//                                           >
//                                             {moment(data.createdAt).format(
//                                               "DD-MM-YYYY HH:mm"
//                                             )}
//                                           </span>
//                                         </TableCell> 
//                                       )}*/}
//                                     </TableRow>
//                                   ))}
//                                 </TableBody>
//                               </Table>
//                             </TableContainer>
//                           )}
//                         </Form>
//                       )}
//                     </Formik>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <Footer />
//       </div>
//     );
//   }
// }

// export default withRouter(Notifications);






import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';

import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Menu from '../Component/Menu';

import Credentials, {
  currentTenant,
  userid
} from '../Common/Credentials';

import withRouter from '../withRouter';

import NotificationServices from './NotificationServices';

import {
  Bell,
  Crown,
  User,
  ShoppingCart,
  ShoppingBag,
  Factory,
  Landmark,
  ChevronDown,
  Boxes,
  Sparkles,
  Search,
  Loader2,
  CheckCheck
} from 'lucide-react';

const iconMap = {
  Masters: Crown,
  Accounts: User,
  Inventory: Boxes,
  Sales: ShoppingCart,
  Purchase: ShoppingBag,
  Production: Factory,
  Assets: Landmark
};

const colorMap = {
  Masters: {
    bg: 'tw-bg-violet-50',
    hovbg: 'group-hover:tw-bg-violet-100',
    text: 'tw-text-violet-600'
  },
  Accounts: {
    bg: 'tw-bg-blue-50',
    hovbg: 'group-hover:tw-bg-blue-100',
    text: 'tw-text-blue-600'
  },
  Inventory: {
    bg: 'tw-bg-emerald-50',
    hovbg: 'group-hover:tw-bg-emerald-100',
    text: 'tw-text-emerald-600'
  },
  Sales: {
    bg: 'tw-bg-amber-50',
    hovbg: 'group-hover:tw-bg-amber-100',
    text: 'tw-text-amber-600'
  },
  Purchase: {
    bg: 'tw-bg-purple-50',
    hovbg: 'group-hover:tw-bg-purple-100',
    text: 'tw-text-purple-600'
  },
  Production: {
    bg: 'tw-bg-rose-50',
    hovbg: 'group-hover:tw-bg-rose-100',
    text: 'tw-text-rose-600'
  },
  Assets: {
    bg: 'tw-bg-cyan-50',
    hovbg: 'group-hover:tw-bg-cyan-100',
    text: 'tw-text-cyan-600'
  }
};

function Notifications(props) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [notificationType, setNotificationType] =
    useState('Product Based');
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (userid === undefined) {
      window.confirm(
        'Your Session is Lost: Please login Back to resume'
      );

      props.navigate(`/`);
    }

    Credentials.setSelectedMenu('Notifications');

    refresh();
  }, []);

  const refresh = () => {
    setLoading(true);

    NotificationServices.GetAllNotifications(
      currentTenant,
      userid
    )
      .then((res) => {
        setData(
          res.data.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : -1
          )
        );
      })
      .catch((e) => {
        if (e.response?.data?.error === 'Unauthorized') {
          alert(
            'Your Session is Lost: Please login Back to resume'
          );

          props.navigate(`/`);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleRead = (id) => {
    NotificationServices.NotificationsReadStatus(id)
      .then(() => {
        refresh();
      })
      .catch((e) => {
        if (e.response?.data?.error === 'Unauthorized') {
          alert(
            'Your Session is Lost: Please login Back to resume'
          );

          props.navigate(`/`);
        }
      });
  };

  const markAllAsRead = () => {
    NotificationServices.MarkAllasRead(
      currentTenant,
      userid
    )
      .then(() => {
        refresh();
      })
      .catch((e) => {
        if (e.response?.data?.error === 'Unauthorized') {
          alert(
            'Your Session is Lost: Please login Back to resume'
          );

          props.navigate(`/`);
        }
      });
  };

  const groupedData = useMemo(() => {
    const products = [
      'Masters',
      'Accounts',
      'Inventory',
      'Sales',
      'Purchase',
      'Production',
      'Assets'
    ];

    return products.map((product) => ({
      name: product,
      items: data.filter(
        (item) =>
          item.product === product &&
          (item.subject || '')
            .toLowerCase()
            .includes(search.toLowerCase())
      )
    }));
  }, [data, search]);

  const filteredAllNotifications = useMemo(() => {
    return data.filter(
      (item) =>
        (item.subject || '')
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        (item.content || '')
          .toLowerCase()
          .includes(search.toLowerCase())
    );
  }, [data, search]);

  const unreadCount = data.filter(
    (e) => e.notificationstatus === 0
  ).length;

  const toggleAccordion = (name) => {
    setExpanded((prev) => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper tw-bg-[#f4f7fc] tw-p-4">
        <div className="tw-rounded-[24px] tw-border tw-border-slate-200 tw-bg-white tw-shadow-sm">
          {/* Header */}
          <div className="tw-border-b tw-border-slate-100 tw-px-5 tw-py-4">
            <div className="tw-flex tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-items-center lg:tw-justify-between">
              <div className="tw-flex tw-items-center tw-gap-4">
                <div className="tw-relative tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-2xl tw-bg-gradient-to-br tw-from-blue-500 tw-to-indigo-600">
                  <Bell className="tw-h-5 tw-w-5 tw-text-white" />

                  <div className="tw-absolute tw--right-1 tw--top-1 tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-white">
                    <Sparkles className="tw-h-3 tw-w-3 tw-text-amber-500" />
                  </div>
                </div>

                <div>
                  <div className="tw-flex tw-items-center tw-gap-2">
                    <h1 className="tw-text-[22px] tw-font-bold tw-text-slate-900">
                      Notifications
                    </h1>

                    <span className="tw-rounded-full tw-border tw-border-blue-200 tw-bg-blue-50 tw-px-2.5 tw-py-1 tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-blue-600">
                      {unreadCount} Unread
                    </span>
                  </div>

                  <p className="tw-mt-1 tw-text-xs tw-font-medium tw-text-slate-500">
                    Monitor activities and real-time updates
                  </p>
                </div>
              </div>

              <div className="tw-flex tw-items-center tw-gap-2">
                <div className="tw-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2">
                  <Search className="tw-h-3.5 tw-w-3.5 tw-text-slate-400" />

                  <input
                    value={search}
                    onChange={(e) =>
                      setSearch(e.target.value)
                    }
                    placeholder="Search..."
                    className="tw-w-40 tw-border-none tw-bg-transparent tw-text-xs tw-font-medium tw-text-slate-700 tw-outline-none"
                  />
                </div>

                {unreadCount > 0 && (
                  <button
                    onClick={markAllAsRead}
                    className="tw-flex tw-items-center tw-gap-2 tw-rounded-xl tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-transition-all hover:tw-scale-105"
                  >
                    <CheckCheck className="tw-h-3.5 tw-w-3.5" />
                    Mark all read
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="tw-p-5">
            <div className="tw-flex tw-gap-2 tw-rounded-2xl tw-bg-slate-100 tw-p-1.5">
              <button
                onClick={() =>
                  setNotificationType('Product Based')
                }
                className={`tw-flex-1 tw-rounded-xl tw-py-3 tw-text-xs tw-font-bold tw-border-none tw-outline-none focus:tw-outline-none tw-uppercase tw-transition-all ${
                  notificationType === 'Product Based'
                    ? 'tw-bg-white tw-text-blue-600 tw-shadow-sm'
                    : 'tw-text-slate-500'
                }`}
              >
                Product Based
              </button>

              <button
                onClick={() =>
                  setNotificationType('All')
                }
                className={`tw-flex-1 tw-rounded-xl tw-py-3 tw-text-xs tw-font-bold tw-border-none tw-outline-none focus:tw-outline-none tw-uppercase tw-transition-all ${
                  notificationType === 'All'
                    ? 'tw-bg-white tw-text-blue-600 tw-shadow-sm'
                    : 'tw-text-slate-500'
                }`}
              >
                All Notifications
              </button>
            </div>

            {/* Loading */}
            {loading ? (
              <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
                <Loader2 className="tw-h-8 tw-w-8 tw-animate-spin tw-text-blue-600" />
              </div>
            ) : (
              <>
                {notificationType === 'Product Based' ? (
                  <div className="tw-mt-5 tw-space-y-3">
                    {groupedData.map((section, index) => {
                      const Icon =
                        iconMap[section.name] || Bell;

                      const colors =
                        colorMap[section.name];

                      const unread =
                        section.items.filter(
                          (x) =>
                            x.notificationstatus === 0
                        ).length;

                      return (
                        <div
                          key={index}
                          className="tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white tw-group"
                        >
                          <div
                            onClick={() =>
                              toggleAccordion(section.name)
                            }
                            className="tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-p-2 tw-px-4"
                          >
                            <div className="tw-flex tw-items-center tw-gap-4">
                              <div
                                className={`tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-2xl ${colors.bg} ${colors.hovbg}`}
                              >
                                <Icon
                                  className={`tw-h-5 tw-w-5 ${colors.text}`}
                                />
                              </div>

                              <div>
                                <div className="tw-flex tw-items-center tw-gap-2">
                                  <h3 className="tw-text-[16px] tw-font-semibold tw-text-slate-900">
                                    {section.name}
                                  </h3>

                                  <span className="tw-rounded-full tw-bg-slate-100 tw-px-3 tw-py-1 tw-text-[11px] tw-font-bold">
                                    {unread > 0
                                      ? `${unread}/${section.items.length}`
                                      : section.items.length}
                                  </span>
                                </div>

                                <p className="tw-mt-0.5 tw-mb-0 tw-text-[11px] tw-text-slate-500">
                                  Latest activities and updates
                                </p>
                              </div>
                            </div>

                            <ChevronDown
                              className={`tw-h-4 tw-w-4 tw-transition-transform ${
                                expanded[section.name]
                                  ? 'tw-rotate-180'
                                  : ''
                              }`}
                            />
                          </div>

                          {expanded[section.name] && (
                            <div className="tw-border-t tw-border-slate-100 tw-p-3">
                              {section.items.length > 0 ? (
                                <div className="tw-space-y-2">
                                  {section.items.map(
                                    (item, idx) => (
                                      <div
                                        key={idx}
                                        onClick={() =>
                                          item.notificationstatus ===
                                            0 &&
                                          handleRead(item.id)
                                        }
                                        className="tw-cursor-pointer tw-rounded-xl tw-border tw-border-slate-100 tw-bg-slate-50 tw-p-3 tw-transition-all hover:tw-bg-white hover:tw-shadow-sm"
                                      >
                                        <div className="tw-flex tw-items-start tw-gap-3">
                                          <div>
                                            {item.notificationstatus ===
                                            0 ? (
                                              <div className="tw-mt-1.5 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-blue-500" />
                                            ) : (
                                              <div className="tw-mt-1 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-bg-emerald-100">
                                                <CheckCheck className="tw-h-2.5 tw-w-2.5 tw-text-emerald-600" />
                                              </div>
                                            )}
                                          </div>

                                          <div className="tw-flex-1">
                                            <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
                                              <div>
                                                <h4 className="tw-text-sm tw-font-semibold tw-text-slate-800">
                                                  {item.createdbyname &&
                                                    `${item.createdbyname} - `}
                                                  {item.subject}
                                                </h4>

                                                <p className="tw-mt-1 tw-mb-1 tw-text-xs tw-text-slate-600">
                                                  {item.content}
                                                </p>
                                              </div>

                                              <span className="tw-whitespace-nowrap tw-text-[10px] tw-font-medium tw-text-slate-400">
                                                {moment(
                                                  item.createdAt
                                                ).format(
                                                  'DD-MM-YYYY HH:mm'
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              ) : (
                                <div className="tw-py-5 tw-text-center tw-text-xs tw-text-slate-400">
                                  No notifications available
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="tw-mt-5 tw-space-y-3">
                    {filteredAllNotifications.map(
                      (item, index) => (
                        <div
                          key={index}
                          onClick={() =>
                            item.notificationstatus === 0 &&
                            handleRead(item.id)
                          }
                          className="tw-cursor-pointer tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-blue-50/50 tw-p-4 tw-transition-all hover:tw-shadow-sm"
                        >
                          <div className="tw-flex tw-items-start tw-gap-3">
                            <div>
                              {item.notificationstatus ===
                              0 ? (
                                <div className="tw-mt-1.5 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-blue-500" />
                              ) : (
                                <div className="tw-mt-1 tw-flex tw-h-4 tw-w-4 tw-items-center tw-justify-center tw-rounded-full tw-bg-emerald-100">
                                  <CheckCheck className="tw-h-2.5 tw-w-2.5 tw-text-emerald-600" />
                                </div>
                              )}
                            </div>

                            <div className="tw-flex-1">
                              <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
                                <div>
                                  <div className="tw-flex tw-items-center tw-gap-2">
                                    <span className="tw-rounded-full tw-bg-blue-50 tw-px-2 tw-py-1 tw-text-[10px] tw-font-bold tw-text-blue-600">
                                      {item.product}
                                    </span>

                                    <h4 className="tw-text-sm tw-font-semibold tw-text-slate-800">
                                      {item.createdbyname &&
                                        `${item.createdbyname} - `}
                                      {item.subject}
                                    </h4>
                                  </div>

                                  <p className="tw-my-1 tw-text-xs tw-text-slate-600">
                                    {item.content}
                                  </p>
                                </div>

                                <span className="tw-whitespace-nowrap tw-text-[10px] tw-font-medium tw-text-slate-400">
                                  {moment(
                                    item.createdAt
                                  ).format(
                                    'DD-MM-YYYY HH:mm'
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default withRouter(Notifications);